import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import './SuccessMessage.scss';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import IconLetter from './svgComponents/IconLetter';
import LogoMobile from './svgComponents/LogoMobile';
import CancelIcon from './svgComponents/CancelIcon';

const SuccessMessage = ({ isActiveMsg, setIsActiveMsg }) => {
  useEffect(() => {
    if (isActiveMsg) {
      // eslint-disable-next-line no-undef
      const targetElement = document.querySelector('#successMessage');
      disableBodyScroll(targetElement);
    }
    setTimeout(() => {
      clearAllBodyScrollLocks();
      setIsActiveMsg(false);
    }, 4000);
  }, [isActiveMsg, setIsActiveMsg]);

  return (
    <>
      {isActiveMsg && (
        <div className="success" id="successMessage">
          <div className="success__container">
            <Link to="/">
              <LogoMobile className="success__logo" />
            </Link>
            <Link to="/" className="success__exit">
              <CancelIcon />
            </Link>
            <IconLetter className="success__letter" />
            <h2>we received your message</h2>
            <p>see you soon!</p>
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessMessage;
